import { FC, ReactNode } from 'react';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useAppDispatch, useAppSelector } from 'src/app/reduxCustomHooks';
import { completePasswordSetupAction } from 'src/app/slices/authSlice';
import { ChangePassword } from 'src/components/organisms/changePassword/ChangePassword';
import LoginTemplate from 'src/components/templates/LoginTemplate';
import { needsPasswordSetup } from './needsPasswordSetup';

export const PasswordSetupGate: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const token = useAppSelector((state) => state.auth.token);
  const user = useAppSelector((state) => state.auth.user);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const title = t('passwordSetup.title', 'Set a password') || 'Set a password';
  const description =
    t('passwordSetup.body', 'Choose a password before you continue.') ||
    'Choose a password before you continue.';

  if (!needsPasswordSetup(token, user)) return <>{children}</>;

  return (
    <LoginTemplate>
      <Box
        component="section"
        aria-label={title}
        sx={{ maxWidth: 480, mx: 'auto' }}
      >
        <ChangePassword
          hideCancel
          passwordSetup
          title={title}
          description={description}
          onCloseClick={() => dispatch(completePasswordSetupAction())}
        />
      </Box>
    </LoginTemplate>
  );
};
